const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  ENTITY: '/entity',
  APPOINTMENT: '/appointment',
  BRANCH: '/branch',
  STAFF: '/staff',
  EXERCISE: '/exercise',
  PATIENT: '/patient',
  INVALID: '/invalid'
};

export const paths = {
  // Auth
  auth: {
    login: `${ROOTS.AUTH}/login`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
  },
  // Dashboard
  dashboard: {
    dashboard: ROOTS.DASHBOARD,
    variant: {
      practitioner: `${ROOTS.DASHBOARD}/practitioner`,
      assistant: `${ROOTS.DASHBOARD}/assistant`,
      platformAdmin: `${ROOTS.DASHBOARD}/platform-admin`,
      businessAdmin: `${ROOTS.DASHBOARD}/business-admin`,
      branchAdmin: `${ROOTS.DASHBOARD}/branch-admin`,
    },
  },
  entity: {
    index: `${ROOTS.ENTITY}`,
    onboard: `${ROOTS.ENTITY}/onboard`,
    view: `${ROOTS.ENTITY}/view-entity/:entityId/:entityName`,
  },
  appointment: {
    index: `${ROOTS.APPOINTMENT}`,
  },
  staff: {
    index: `${ROOTS.STAFF}`,
    onboard: `${ROOTS.STAFF}/onboard`,
    view: `${ROOTS.STAFF}/view-staff/:staffId`,
  },
  branch: {
    index: `${ROOTS.BRANCH}`,
    onboard: `${ROOTS.BRANCH}/onboard`,
    view: `${ROOTS.BRANCH}/view-branch/:branchId/:branchName`,
  },
  exercise: {
    index: `${ROOTS.EXERCISE}`,
    onboard: `${ROOTS.EXERCISE}/exercises`,
  },
  patient: {
    index: `${ROOTS.PATIENT}`,
    onboard: `${ROOTS.PATIENT}/onboard`,
    root: `${ROOTS.PATIENT}/onboard-patient`,
    masterAssessment: `${ROOTS.PATIENT}/manage/:patientId/master-assessment/:masterAssessmentId`,
  },
  invalid: {
    index: `${ROOTS.INVALID}`
  }
};

export function getPageTitleByPath(path: string) {
  const pathArray = path.split('/');
  const pathName = pathArray[pathArray.length - 1];
  const pathNameArray = pathName.split('-');
  const pathNameArrayCapitalized = pathNameArray.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return pathNameArrayCapitalized.join(' ');
}